export const defaultOnlineMeetingProviderName = 'Microsoft Teams';
